import { getAuthData } from '../utils/authStorage';

const resolveToken = () => {
    const authData = getAuthData();
    if (authData?.token) {
        return authData.token;
    }

    const sessionToken = typeof sessionStorage !== 'undefined' ? sessionStorage.getItem('token') : null;
    if (sessionToken) {
        return sessionToken;
    }

    return null;
};

const buildHeaders = (headerobject = {}, baseKey, requireAuth = true) => {
    const token = resolveToken();
    if (requireAuth && !token) {
        // Don't perform global redirects from this helper — keep it a pure header builder.
        // Consumers (routes/components) should decide how to handle missing tokens.
        return { headers: {} };
    }

    // Special-case override: when serving the public StoreExpress page for store 755629,
    // use the fixed ENCRYKEY supplied for that public route.
    let finalBaseKey = baseKey;
    try {
        if (typeof window !== 'undefined' && window.location && String(window.location.pathname).includes('/storeExpress/755629')) {
            finalBaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpYXQiOjE3Njk2ODg5OTEsInN0b3JlX2lkcyI6WyI2Nzk0ZWYyNDc0OGE2OTM0NTA2ZTM2M2MiXSwidXNlcl9pZHMiOlsiNjgwMjYwZDcyNzBmMDdmOTQ1NmMwYjk1Il0sImV4cGlyZXNfYXQiOm51bGx9.c9865646f9762a5c3c8a3934ebbbebe7';
        }
    } catch (err) {
        // ignore
    }

    const headers = {
        'Content-Type': headerobject['Content-Type'] || 'application/json',
        'ENCRYKEY': finalBaseKey,
        ...headerobject,
    };

    if (token) {
        headers.Authorization = `Bearer ${token}`;
    }

    return { headers };
};

const header = (headerobject = {}) => buildHeaders(headerobject, process.env.REACT_APP_KEY_PEGASUS, true);

const headerPublic = (headerobject = {}) => buildHeaders(headerobject, process.env.REACT_APP_KEY_PEGASUS_PUBLIC, false);

export { header, headerPublic };

// Auto-inject Authorization and ENCRYKEY into all global fetch calls when running in browser.
// This ensures existing direct `fetch()` usages also receive the Bearer token if available.
try {
    if (typeof window !== 'undefined' && typeof window.fetch === 'function') {
        const _origFetch = window.fetch.bind(window);
        window.fetch = async (input, init = {}) => {
            try {
                const token = resolveToken();
                let baseKey = process.env.REACT_APP_KEY_PEGASUS || '';
                try {
                    if (typeof window !== 'undefined' && window.location && String(window.location.pathname).includes('/storeExpress/755629')) {
                        baseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpYXQiOjE3Njk2ODg5OTEsInN0b3JlX2lkcyI6WyI2Nzk0ZWYyNDc0OGE2OTM0NTA2ZTM2M2MiXSwidXNlcl9pZHMiOlsiNjgwMjYwZDcyNzBmMDdmOTQ1NmMwYjk1Il0sImV4cGlyZXNfYXQiOm51bGx9.c9865646f9762a5c3c8a3934ebbbebe7';
                    }
                } catch (err) {
                    // ignore
                }
                // clone and normalize init
                const newInit = Object.assign({}, init);
                newInit.headers = Object.assign({}, (init && init.headers) || {});
                // ensure ENCRYKEY present
                if (baseKey && !Object.keys(newInit.headers).some(k => k.toLowerCase() === 'encrykey')) {
                    newInit.headers['ENCRYKEY'] = baseKey;
                }
                // ensure Authorization if token exists and not already set
                if (token && !Object.keys(newInit.headers).some(k => k.toLowerCase() === 'authorization')) {
                    newInit.headers['Authorization'] = `Bearer ${token}`;
                }
                return await _origFetch(input, newInit);
            } catch (err) {
                return await _origFetch(input, init);
            }
        };
    }
} catch (err) {
    // ignore environment where patching is not possible
}
